import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { AgentSectionCard } from './AgentSectionCard';
import { useAgentSections } from './useAgentSections';

// TODO: cleanup with cp_annotation_createproject_agent ff

/** Custom prompt sections below the concept list. With no sections, only the button shows. */
export const AgentSections = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { savedSections, newSectionIds, handleAddSection, handleNewSectionResolved } =
    useAgentSections();

  return (
    <Box id="agent-sections">
      <Typography variant="subtitle1" sx={{ mb: theme.spacing(4) }}>
        {formatMessage({ id: 'createProjectWizard.step.annotationAgent.sections.title' })}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3) }}>
        {savedSections.map((section) => (
          <AgentSectionCard
            key={section.id}
            id={section.id}
            section={section}
            onNewSectionResolved={handleNewSectionResolved}
          />
        ))}
        {newSectionIds.map((id) => (
          <AgentSectionCard
            key={id}
            id={id}
            section={undefined}
            onNewSectionResolved={handleNewSectionResolved}
          />
        ))}
        <Button
          id="agent-sections-add-button"
          variant="outlined"
          startIcon="add"
          displayLabel={formatMessage({
            id: 'createProjectWizard.step.annotationAgent.sections.add',
          })}
          onClickHandler={handleAddSection}
          sx={{ textTransform: 'none', width: '100%' }}
        />
      </Box>
    </Box>
  );
};
